// extracted by mini-css-extract-plugin
module.exports = {"u-fullWidth":"styles_u-fullWidth__1ONj4","u-shrinkAll":"styles_u-shrinkAll__NqiHJ","SelectItem":"styles_SelectItem__2d-Ix"};